/**
 * @generated SignedSource<<5b421905774452b5ce0c307bcb03c96b>>
 * @relayHash 297d8cf766cfae74d2631c06b094a254
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a242eda74a13ae6c0a9260b1a76cf9c5eda3869efbd6ec6f6d696a454094cd38

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type EcosystemBackgroundScriptsWithLoaderQuery$variables = {
  cloudId: string;
  issueKey: string;
};
export type EcosystemBackgroundScriptsWithLoaderQuery$data = {
  readonly jira: {
    readonly issueByKey: {
      readonly " $fragmentSpreads": FragmentRefs<"EcosystemBackgroundScripts">;
    } | null;
  };
};
export type EcosystemBackgroundScriptsWithLoaderQuery = {
  response: EcosystemBackgroundScriptsWithLoaderQuery$data;
  variables: EcosystemBackgroundScriptsWithLoaderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueKey"
},
v2 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "issueKey"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "EcosystemBackgroundScriptsWithLoaderQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "args": (v2/*: any*/),
              "concreteType": "JiraIssue",
              "kind": "LinkedField",
              "name": "issueByKey",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "EcosystemBackgroundScripts"
                }
              ]
            }
          ]
        },
        "action": "THROW"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "EcosystemBackgroundScriptsWithLoaderQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issueByKey",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueConnectBackgroundScriptConnection",
                "kind": "LinkedField",
                "name": "connectBackgroundScripts",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraIssueConnectBackgroundScriptEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraIssueConnectBackgroundScript",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "shouldReloadOnRefresh"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "addonKey"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "moduleKey"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "options"
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "a242eda74a13ae6c0a9260b1a76cf9c5eda3869efbd6ec6f6d696a454094cd38",
    "metadata": {},
    "name": "EcosystemBackgroundScriptsWithLoaderQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "1451d648926379a040fb01b943af0a46";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
